{
  "accueil": "home",
  "rendez-vous": "rendezvous"
}
